import { gql } from '@apollo/client'
import { STORE_FRAGMENT } from '../fragments'

export const GET_STORES_WITH_FILTER = gql`
  query GetStoresWithFilter($input: CompanyStoresWithFilterInput!) {
    companyStoresWithFilter(input: $input) {
      hasMore
      count
      results {
        ...Store
      }
    }
  }
  ${STORE_FRAGMENT}
`
